module.exports = __webpack_public_path__ + "assets/icon-blue-check.45e77043.svg";